import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as CloseIcon } from "../assets/close_icon.svg";
import { ReactComponent as Logo } from "../assets/uido_logo_black.svg";
import Navigation from "./Navigation.jsx";
import { ReactComponent as Message } from "../assets/message.svg";
import { switchLanguageWithFade } from "../utils/languageSwitch";
// import { useTheme } from "../context/ThemeContext"; // Unused for now
import ButtonWithIcon from "./ButtonWithIcon";

const MobileMenuComponent = ({ buttonOnClickPrimary, toggleMenu }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isConsultationOpen, setConsultationOpen] = useState(false);
  const [isConsultationClosing, setConsultationClosing] = useState(false);
  const [isLanguageSwitching, setIsLanguageSwitching] = useState(false);
  // const { isMatrixEnabled, toggleMatrix } = useTheme(); // Unused for now

  const changeLanguage = async (lng) => {
    if (isLanguageSwitching) return;

    setIsLanguageSwitching(true);
    try {
      await switchLanguageWithFade({
        lng,
        i18n,
        location,
        navigate,
      });
    } finally {
      setIsLanguageSwitching(false);
    }
  };

  const closeConsultation = () => setConsultationOpen(false);

  useEffect(() => {
    const onClickOutside = (e) => {
      const wrapper = document.querySelector('.mobile-consultation-wrapper');
      if (wrapper && !wrapper.contains(e.target)) {
        if (isConsultationOpen) {
          setConsultationOpen(false);
          setConsultationClosing(true);
          setTimeout(() => setConsultationClosing(false), 450);
        }
      }
    };
    if (isConsultationOpen) {
      document.addEventListener('click', onClickOutside);
    }
    return () => document.removeEventListener('click', onClickOutside);
  }, [isConsultationOpen]);

  const handleOptionConsultation = () => {
    closeConsultation();
    buttonOnClickPrimary();
  };

  const handleOptionForm = () => {
    closeConsultation();
    toggleMenu(); // Close mobile menu
    const form = document.querySelector('#form');
    if (form) {
      const top = form.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: top + 80, behavior: 'smooth' });
    }
  };

  const handleOptionPhone = () => {
    closeConsultation();
    toggleMenu(); // Close mobile menu
    const footer = document.querySelector('[data-section="contact-footer"]');
    if (footer) footer.scrollIntoView({ behavior: 'smooth' });
  };

  const handleOptionEmail = () => {
    closeConsultation();
    toggleMenu(); // Close mobile menu
    const footer = document.querySelector('[data-section="contact-footer"]');
    if (footer) footer.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="mobile-menu-overlay">
      <div className="mobile-menu-header">
        <div className="logo">
          <Logo />
          <div className="lang">
            <button
              className={`clickable-button polish ${
                i18n.language === "pl" ? "active" : ""
              }`}
              onClick={() => changeLanguage("pl")}
              disabled={isLanguageSwitching}
            >
              PL
            </button>
            <button
              className={`clickable-button english ${
                i18n.language === "en" ? "active" : ""
              }`}
              onClick={() => changeLanguage("en")}
              disabled={isLanguageSwitching}
            >
              EN
            </button>
          </div>
        </div>

        <div className="close-icon" onClick={toggleMenu}>
          <CloseIcon />
        </div>
      </div>

      <div className="mobile-menu-content">
        <h3 className="menu-title">{t("menu.title")}</h3>
        {/* removed toggle in mobile menu per request */}
        <Navigation onLinkClick={toggleMenu} />
        
        <div className={`mobile-consultation-wrapper consultation-wrapper${isConsultationOpen ? ' is-open' : ''}${isConsultationClosing ? ' is-closing' : ''}`}>
          <ButtonWithIcon onClick={(e) => { e.stopPropagation(); setConsultationOpen(!isConsultationOpen); }} iconLeft={Message}>
            {t("cta.consultation")}
          </ButtonWithIcon>
          <div className="consultation-dropdown" role="menu" aria-label="consultation-options">
            <button type="button" className="consultation-option" onClick={handleOptionConsultation}>
              <span className="option-label">{t("consultation.option.15min")}</span>
            </button>
            <button type="button" className="consultation-option" onClick={handleOptionForm}>
              <span className="option-label">{t("consultation.option.form")}</span>
            </button>
            <button type="button" className="consultation-option" onClick={handleOptionPhone}>
              <span className="option-label">{t("consultation.option.phone")}</span>
            </button>
            <button type="button" className="consultation-option" onClick={handleOptionEmail}>
              <span className="option-label">{t("consultation.option.email")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenuComponent;
